import React, {useEffect, useRef, useState} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {ICharThread} from "../../_interfaces/iCharThread";
import {s_char_threads} from "../../_signals/s_char";
import {ThreadUpdate} from "../../_api/BEThreads";
import {useSignals} from "@preact/signals-react/runtime";

interface IProp {
    open: ICharThread | null,
    isOpen: (open: boolean) => void
}

export default function ThreadsEdit({open, isOpen}: IProp) {
    useSignals()

    const startwith = [100, 200, 300, 500, 800];
    const descRef = useRef<HTMLInputElement>(null);
    const nameRef = useRef<HTMLInputElement>(null);

    const [threadlpstart, setthreadlpstart] = useState(0)

    useEffect(()=>{
        if (open) setthreadlpstart(open.lpstart)
    },[open])

    const savethread = () => {
        if (!open) return

        let threads = s_char_threads.value;
        threads = threads.map(t => {
            if (t.id === open.id) {
                t.name = nameRef.current?.value ?? t.name;
                t.descr = descRef.current?.value ?? t.descr
                t.lpstart= threadlpstart
                ThreadUpdate(t)
            }
            return t
        })
        s_char_threads.value = threads

        isOpen(false)
    }

    return <Dialog open={!!open}>
        <DialogContent>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={open?.name??''}
                    inputRef={nameRef}
                    label={"threadname"}
                />
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <InputLabel id="threadstartwith_label">threadstartwith</InputLabel>
                <Select
                    labelId="threadstartwith_label"
                    value={threadlpstart}
                    style={{width: "100%"}}
                >
                    {startwith.map(a => <MenuItem key={v4()}
                                                  value={a}
                                                  onClick={() => setthreadlpstart(a)}>
                        {a}
                    </MenuItem>)}
                </Select>
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <InputLabel id="threadstartwith_label">descr</InputLabel>
                <TextField
                    defaultValue={open?.descr??''}
                    style={{width: "100%"}}
                    inputRef={descRef}
                >
                </TextField>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => savethread()}><CheckIcon/></Button>
            <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>

}

